/**
 * Safe localStorage wrappers for restricted browser modes (Safari private, etc.).
 * localStorage.getItem/setItem can throw SecurityError in those contexts.
 */

export function safeGetItem(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Ignore — app works without persistence
  }
}
